import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { I18n } from 'react-redux-i18n';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { isSubmitting, isValid, submit } from 'redux-form';

import Button from '@material-ui/core/Button';

import Form from './InvoiceReduxForm';

import { FORM_NAME } from './index';
import { setInvoiceData } from '../../../redux/invoice';
import PageBase from '../../../app/PageBase';

const mapStateToProps = state => ({
  submitting: isSubmitting(FORM_NAME)(state),
  valid: isValid(FORM_NAME)(state),
  invoiceId: state.invoiceReducer.invoiceId,
  open: state.invoiceReducer.open,
  invoiceData: state.invoiceReducer.invoiceData,

});
const mapDispatchToProps = {
  submit,
  setInvoiceData,
};

class InvoiceDialog extends Component {

  static propTypes = {
    onClose: PropTypes.func,
  };

  static defaultProps = {
    onClose: () => console.log('create!'),
  };

  submit = () => this.props.submit(FORM_NAME);

  close = () => this.props.history.push('/invoice/list/');

  onSubmitSuccess = () => this.props.onSubmitSuccess();

  render() {

    const {
      open, invoiceId, invoiceData, submitting, valid, consultMode,
    } = this.props;

    const dialogActions = [
      <Button
        label={I18n.t('application.close')}
        onTouchTap={this.close}
        disabled={submitting}
      />,
      <Button
        label={I18n.t('application.save')}
        primary
        keyboardFocused
        onTouchTap={this.submit}
        disabled={submitting || !valid}
      />,
    ];


    let title = invoiceId ? I18n.t('titles.edit') : I18n.t('titles.create');
    title += I18n.t('titles.invoice');
    return (

      <div>
        <PageBase
          title={title}
          showSaveButton
          handleCloseClick={this.close}
          handleSaveClick={this.submit}
          disableSaveButton={submitting || !valid}
        >
          <Form
            onSubmitSuccess={this.close}
          />

        </PageBase>

      </div>


    );

  }

}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(InvoiceDialog));



// WEBPACK FOOTER //
// ./src/components/tracker/Invoices/InvoiceForm.js